import React from 'react'
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom'
import ErrorFallback from '../../utils/ErrorPage';

function MainActivity() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
          <div className=" w-full h-full">
    <Outlet />
  </div>
    </ErrorBoundary>
  )
}

export default MainActivity;